import { EventTypeCode, ListEventsPayload, ListEventsQueryPayload } from '@src/entities/Event/includes/types';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';

export const DefaultListEventsPayload: ListEventsPayload = {
  endDate: dayjs(new Date()).add(6, 'months').format('YYYY-MM-DD'),
  eventTypeCodeList: ['OTHER'] as EventTypeCode[],
  page: 0,
  size: 25,
  sort: 'startDate,desc',
  startDate: dayjs(new Date()).subtract(6, 'months').format('YYYY-MM-DD'),
};

export const DefaultListEventsQueryPayload: ListEventsQueryPayload = ['Event', 'ListEvents', DefaultListEventsPayload];
